export default "/images/product-3.png?46a7e2fb49744e62a2c84e34a1809429";